import {
  Container,
  Row,
  Col,
  Nav,
  NavItem,
  NavLink,
  Form,
  InputGroupText,
  Input,
  Button,
} from 'reactstrap';
import { useTranslator, useAppContext } from '@front-activerse/common-components';

const FavMealsFilters = ({
  favMeals,
  active,
  setActive,
  search,
  handleChange,
  handleSubmit,
  useSearchResult,
  handleReset,
}) => {
  const { t } = useTranslator();
  const {
    images: { searchIcon },
  } = useAppContext();

  const categoryArray = [];

  if (favMeals) {
    const sortedFavMeals = [...favMeals].sort((a, b) =>
      // eslint-disable-next-line no-nested-ternary
      a.mealType > b.mealType ? 1 : b.mealType > a.mealType ? -1 : 0
    );

    sortedFavMeals.forEach((meal) => {
      if (!categoryArray.includes(meal.name) && meal.name) {
        categoryArray.push(meal.name);
      }
    });
  }

  if (
    (categoryArray.length === 1 && active !== 'all') ||
    (!categoryArray.includes(active) && active !== 'all')
  ) {
    setActive('all');
  }

  return (
    <>
      <Row>
        <Col md={{ size: 8, offset: 2 }}>
          <div className="search-container">
            <Form onSubmit={handleSubmit}>
              <div className="input-group-with-addon start">
                <InputGroupText>
                  <img src={searchIcon} alt="search" />
                </InputGroupText>
                <Input
                  name="search"
                  type="search"
                  value={search}
                  onChange={handleChange}
                  placeholder={t('meal.search.inputPlaceholder')}
                />
                {useSearchResult && (
                  <Button color="link" size="sm" onClick={handleReset} className="ms-2">
                    {t('meal.search.cancelButton')}
                  </Button>
                )}
              </div>
            </Form>
          </div>
        </Col>
      </Row>

      <div className="sub-navigation">
        {categoryArray.length > 1 && (
          <Container>
            <Nav className="d-block">
              <NavItem>
                <NavLink active={active === 'all'} onClick={() => setActive('all')}>
                  {t('meal.favorites.filters.all')}
                </NavLink>
              </NavItem>
              {categoryArray.map((category) => (
                <NavItem key={category}>
                  <NavLink active={active === category} onClick={() => setActive(category)}>
                    {category}
                  </NavLink>
                </NavItem>
              ))}
            </Nav>
          </Container>
        )}
      </div>
    </>
  );
};

export default FavMealsFilters;
